/**
 * Acuerdos-Con-Gestores API
 * Acuerdos-Con-Gestores API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GestionResiduosFilterDTO } from './gestionResiduosFilterDTO';
import { IdEntityFilterDTO } from './idEntityFilterDTO';


export interface AportacionDIAcuerdosGestoresFilterDTO { 
    fechaAlta?: Array<string>;
    creadoPor?: Array<string>;
    fechaModificacion?: Array<string>;
    modificadoPor?: Array<string>;
    gestorResiduo?: GestionResiduosFilterDTO;
    fechaRecogida?: Array<string>;
    fechaAceptacion?: Array<string>;
    fechaAportacion?: Array<string>;
    documentoIdentificacion?: Array<string>;
    estado?: IdEntityFilterDTO;
    origen?: AportacionDIAcuerdosGestoresFilterDTO.OrigenEnum;
}
export namespace AportacionDIAcuerdosGestoresFilterDTO {
    export type OrigenEnum = 'SDDRCC' | 'POSEEDOR' | 'SDDRCA' | 'GESTORESACUERDO' | 'ACUERDO_INDIRECTO';
    export const OrigenEnum = {
        Sddrcc: 'SDDRCC' as OrigenEnum,
        Poseedor: 'POSEEDOR' as OrigenEnum,
        Sddrca: 'SDDRCA' as OrigenEnum,
        Gestoresacuerdo: 'GESTORESACUERDO' as OrigenEnum,
        AcuerdoIndirecto: 'ACUERDO_INDIRECTO' as OrigenEnum
    };
}


